import { withInstall } from '@/utils/tool'
import NumberRange from './index.vue'

export default withInstall(NumberRange)
